<template>
  <section class="section Events">
    <div class="modal" :class="{'is-active': flagEventModal}" >
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <form class="new_event">
            <h2> Nuevo Evento </h2>

            <div class="dropzone_content">
              <img v-show="cover" :src="cover" />
              <input
                id="cover2"
                style="display: none"
                type="file"
                ref="fileInput"
                @change="onFileChange($event)"
                accept="image/*"
              />
              <label
                class="dropzone"
                for="cover2"
                :class="{ready: fileInto}"
                @dragover.prevent="dragover($event)"
                @dragleave.prevent="dragleave($event)"
                @drop.prevent="dragFinish(-1,$event)"
              >
                <div class="open_file" v-if="!file.content">
                  <div class="upload">
                    <ion-icon name="cloud-upload-outline" ></ion-icon>
                  </div>
                  <h1>
                    Arrastrar y soltar imagen o
                    <strong>cargar</strong>
                  </h1>
                </div>
                <div class="file_selected" v-else>
                  <div class="upload">
                    <ion-icon name="image-outline"></ion-icon>
                  </div>
                  <h1>
                    <p>{{file.content.name}}</p>
                    <small>
                      {{(file.content.size / 1000 / 1000).toFixed(2)}} Mb
                      <b v-if="!validateSizeFile">( Archivo muy grande, Max: 20 Mb )</b>
                    </small>
                  </h1>
                </div>
              </label>
            </div>

            <input class="input" :class="{'is-danger': !validateName && trigger}" v-model="event.name" type="text" placeholder="Nombre de evento">
            <input class="input" :class="{'is-danger': !validateDate && trigger}" v-model="event.date" type="date" placeholder="Fecha">
            <!-- <input class="input" :class="{'is-danger': !validateTime && trigger}" v-model="event.time" type="time" placeholder="Hora"> -->
            <textarea class="input textarea" v-model="event.description" placeholder="Descripción"></textarea>
            <button class="button is-warning is-rounded" :class="{'is-loading': loading}" @click.prevent="checkEvent()">
              Registrar
            </button>
          </form>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="flagEventModal = false">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    <div class="container">
      <div class="level">
        <h1 class="title level-left">Eventos</h1>
        <a class="button level-right is-warning is-rounded" @click="flagEventModal = true">
          <span class="icon is-small">
            <ion-icon name="add-outline"></ion-icon>
          </span>
          <span>
            Nuevo Evento
          </span>
        </a>
      </div>
      <div class="card empty" v-if="!eventsList.length">
        <div class="empty_wrapper">
          <img src="@/assets/img/empty_events.svg">
          <p> Todavia no hay eventos </p>
        </div>
      </div>
      <div v-else class="card">
        <table class="table">
          <thead>
            <tr>
              <th>nombre</th>
              <th>descripcion</th>
              <th>fecha</th>
              <th>opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="event in eventsList"  :key="event.id">
              <td>{{event.name}}</td>
              <td>{{event.description}}</td>
              <td style="min-width: 200px" >{{event.datetime | moment('DD MMM [de] YYYY')}}</td>
              <td>
                <a @click="deleteEvent(event)">
                  <ion-icon name="trash-outline"></ion-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { storage, firestore } from '@/main'
// import moment from 'moment'
export default {
  data: () => ({
    flagEventModal: false,
    event: {
      name: '',
      date: '',
      time: '',
      description: ''
    },
    eventsList: [],
    loading: false,
    trigger: false,
    cover: '',
    file: {
      content: null
    },
    fileInto: false,
  }),
  mounted () {
    this.getAllEvents()
  },
  methods: {
    dragFinish (i, e) {
      this.file.content = e.dataTransfer.files[0]
      this.cover = URL.createObjectURL(e.dataTransfer.files[0]);
      this.fileInto = false
    },
    dragover () {
      this.fileInto = true
    },
    dragleave () {
      this.fileInto = false
    },
    onFileChange (e) {
      this.file.content = event.target.files[0];
      this.cover = URL.createObjectURL(e.target.files[0]);
    },
    deleteImage(url) {
      const httpsReference = storage.refFromURL(url)
        httpsReference.delete().then(() => {
          console.log('cover deleted')
        }).catch((error) => {
          console.error("Error removing document: ", error)
      })
    },
    async uploadPhoto () {
      this.loading = true
      let metadata = { contentType: this.file.type }
      storage.ref('/covers').child(this.uuid()).put(this.file.content, metadata)
        .then(snapshot =>  snapshot.ref.getDownloadURL())
        .then(url => {
          console.log('imagen guardada', url)
          this.saveEvent(url)
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkEvent () {
      this.trigger = true
      if (this.validateName && this.validateDate && this.validateSizeFile) {
        this.trigger = false
        this.uploadPhoto()
      }
    },
    deleteEvent ({id, url}) {
      if ( confirm('¿Seguro que quieres eliminar este evento?') ) {
        firestore.collection("events").doc(id).delete().then(() => {
          this.eventsList = this.eventsList.filter(e => e.id != id)
          console.log('delete', id, url)
          this.deleteImage(url)
        })
        .catch((error) => {
          console.error("Error removing document: ", error)
        })
      }
    },
    getAllEvents () {
      firestore.collection("events").get()
      .then((snap) => {
        snap.forEach((doc) => {
          const data = doc.data()
          this.eventsList.push({
            id: doc.id,
            name: data.name,
            datetime: data.datetime,
            description: data.description
          })
        })
      })
      .catch(console.error)
    },
    saveEvent(url) {
      this.loading = true
      firestore.collection("events").add({
        name: this.event.name,
        datetime: this.datetime,
        description: this.event.description,
        url: url
      })
      .then((res) => {
        this.eventsList.push({
          id: res.id,
          name: this.event.name,
          datetime: this.datetime,
          description: this.event.description,
          url: url
        })
        this.loading = false
        this.event = {
          name: '',
          date: '',
          time: '',
          description: '',
        }
        this.clearFiles()
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })

      this.flagEventModal = false
    },
    uuid () {
      return 'p_' + Math.random().toString(36).substr(2, 9);
    },
    clearFiles () {
      this.cover = ''
      this.file = {
        content: null
      }
      this.fileInto = false
    },
  },
  computed: {
    datetime () {
      return this.event.date
    },
    validateName () {
      return this.event.name.length > 3
    },
    validateDate () {
      return this.event.date.length != ''
    },
    validateDescription () {
      return this.event.description.length > 0
    },
    // validateTime () {
    //   return this.event.time.length != ''
    // },
    validateSizeFile () {
      return this.file.content && this.file.content.size / 1000 <= 5000
    },
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../../assets/css/_variables.sass'
.Events
  .modal-content
    width: 700px
    .new_event
      padding: 40px
      display: grid
      grid-template-columns: 1fr
      grid-gap: 20px
      // .new_image
      //   padding: 40px
      //   display: grid
      //   grid-template-columns: 1fr
      //   grid-gap: 20px
      .dropzone_content
        width: 100%
        box-sizing: border-box
        position: relative
        .dropzone
          height: 300px
        img
          position: absolute
          left: 0
          top: 0
          width: 100%
          height: 100%
          object-fit: cover
          border-radius: 5px
          width: calc(100% - 30px)
          height: calc(100% - 30px)
          margin: 15px
        .dropzone
          width: 100%
          height: 250px
          background-color: transparent
          border-radius: 5px
          border: 1px dashed darken(#F4F7F8, 10%)
          display: flex
          justify-content: center
          align-items: center
          cursor: pointer
          transition: all ease-in-out .2s
          padding: 20px
          box-sizing: border-box
          position: relative
          z-index: 2
          .open_file, .file_selected
            display: flex
            align-items: center
            background-color: white
            padding: 7px
            padding-right: 25px
            border-radius: 30px
          .file_selected
            small
              font-size: 12px
              font-weight: 400
              margin-top: 2px
              display: block
              b
                color: red
          .upload
            background-color: darken(#F4F7F8, 5%)
            width: 40px
            min-width: 40px
            height: 40px
            border-radius: 50%
            display: flex
            justify-content: center
            align-items: center
            margin-right: 15px
            i
              color: #3273DC
          h1
            font-size: 14px
            font-weight: 500
            p
              line-height: 1.3
              overflow: hidden
              text-overflow: ellipsis
              display: -webkit-box
              -webkit-line-clamp: 1
              -webkit-box-orient: vertical
            strong
              color: #3273DC
          &.ready, &:hover
            background-color: rgba(#F4F7F8, .7)
              border: 1px dashed #3273DC
  .button, .input
    box-sizing: border-box
  h2
    font-weight: 700
  h1
    font-size: 20px
  table
    width: 100%
    td
      line-height: 1.5
  .empty
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    min-height: 300px
    .empty_wrapper
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      p
        text-align: center
        font-weight: 500
        margin-top: 20px
        font-size: 14px
      img
        width: 150px
        margin-left: -10px
</style>